import ImageWrapper from "../ImageWrapper/component";
import { isValidString } from "../../utils/content/library";

/**
 *  @param {Array.<{string}>} list
 *  @param {string} tag - tag can be a regular expression string e.g. "/foo/i".
 *
 *  @returns true if tag was found in list
 */

export const containsTag = (list) => (tag) => {
    const isRegex = /^\/(.+?)\/([gimsu]*)$/.exec(tag);
    if (isRegex) {
        const reg = new RegExp(isRegex[1], isRegex[2]);
        return list.some((item) => reg.test(item));
    }
    return list.includes(tag);
};

/**
 *  @param {Array.<string>} tagList
 *  @param {Array.<string>} tagListSearch
 *
 *  @returns true if every tag was found in tagListSearch.
 */

export const includesEveryTag = (tagList, tagListSearch) => {
    if (
        !Array.isArray(tagList) ||
        tagList.length === 0 ||
        !Array.isArray(tagListSearch) ||
        tagListSearch.length === 0
    ) {
        return false;
    }
    return tagList.every(containsTag(tagListSearch));
};

/**
 * @param {stirng} type
 * @param {Arrray.<{type:string, name:string}>} tags
 * @param {Array.<{type:string, path:string}>} concepts
 *
 * @returns an array of tag, and concpet values matching type.
 */

const getTagValues = (type, tags, concepts) => {
    tags = Array.isArray(tags) ? tags : [];
    concepts = Array.isArray(concepts) ? concepts : [];
    return tags
        .concat(concepts)
        .filter((obj) => obj.type === type && (obj.name || obj.path))
        .map((obj) => obj.namne || obj.path);
};

/**
 *  checks match against tags, and concepts.
 *
 *  @param {{string:Array<{string}>}} match
 *  @param {Arrray.<{type:string, name:string}>} tags
 *  @param {Array.<{type:string, path:string}>} concepts
 *
 *  @returns true if match was found in tags, or concepts.
 */

export const tagsMatched = (match, tags, concepts) => {
    if (!match) {
        return false;
    }
    return Object.keys(match).every((type) => {
        return includesEveryTag(
            match[type],
            getTagValues(type, tags, concepts)
        );
    });
};

/**
 * @param {Object} cta - The Object is checked for tag, and tagPositionAfter properties.
 *
 * @returns {boolean}
 */

export const isCTA = (cta) =>
    cta && cta.tag && (!isNaN(cta.tagPositionAfter) || cta.tagPositionLast);

/**
 *  @param {Arrray.<{type:string, name:string}>} tags
 *  @param {Array.<{type:string, path:string}>} concepts
 *  @param {Array} acc - The default return value, an array.
 *  @param {Object} cta - The object to check match against.
 *
 *  @returns {Array} - Array of valid CTA objects.
 *
 */

export const getCTA = (tags, concepts) => (acc, cta) => {
    if (cta.match && !tagsMatched(cta.match, tags, concepts)) {
        return acc;
    }
    if (cta.not && tagsMatched(cta.not, tags, concepts)) {
        return acc;
    }
    acc.push(cta);
    return acc;
};

export const getImage = (image, alt, moreImageProps) => {
    if (isValidString(image?.url)) {
        const imageProps = {
            url: image.url,
            alt: alt,
            loading: null,
        };

        Object.assign(imageProps, moreImageProps);

        return <ImageWrapper {...imageProps} />;
    }
    return null;
};
